import jsonToJsxComponent from '../jsonToJsxComponent';
import GuidelineSectionTextJson from './GuidelineSectionText.json';
import GuidelineQAndAJson from './GuidelineQAndA.json';

const GuidelineSectionText = jsonToJsxComponent(GuidelineSectionTextJson);
const GuidelineQAndA = jsonToJsxComponent(GuidelineQAndAJson);

export { GuidelineSectionText, GuidelineQAndA };
